<template>
    <div class="tabs-root d-flex align-items-center">
        <div
            v-for="tab in tabs"
            :key="tab.value"
            @click="() => onChange(tab.value)"
            :class="{ selected: tab.value === value }"
            class="tab d-flex align-items-center justify-content-center pa-2 flex-grow clickable"
        >
            <h6 class="text-center heading mb-0">{{ tab.label }}</h6>
            <div
                class="underline"
                :class="{ 'underline-selected': tab.value === value }"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'Tabs',
    props: {
        value: Number,
        tabs: {
            // Value-Label pair
            type: Array,
            default: () => [],
        },
    },
    methods: {
        onChange(value) {
            this.$emit('input', value);
        },
    },
};
</script>

<style scoped>
.tabs-root {
    position: relative;
}

.tab {
    position: relative;
}

.underline {
    position: absolute;
    width: 100%;
    height: 2px;
    bottom: 0;
    left: 0;
    background-color: var(--primary);
    visibility: hidden;
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transition: all 0.22s ease-in-out 0s;
    transition: all 0.22s ease-in-out 0s;
}

.underline-selected {
    visibility: visible;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
}

.heading {
    letter-spacing: 1px;
    font-size: 0.7rem;
    font-weight: 600 !important;
    text-transform: uppercase;
}
</style>
